import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SrInfoDropdown from 'client/components/SrInfoDropdown/SrInfoDropdown';

const SrInfoDropdownController = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const onClick = () => {
    setIsExpanded(!isExpanded);
  };

  return <SrInfoDropdown {...props} isExpanded={isExpanded} onClick={onClick} />;
};

SrInfoDropdownController.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

SrInfoDropdownController.displayName = 'SrInfoDropdownController';

export default SrInfoDropdownController;
